import React from 'react';
import PropTypes from 'prop-types';

import 'sass/GenderIcon.scss';
import {GENDER_COUPLE, GENDER_FEMALE, GENDER_MALE, GENDER_TRANSVESTITE} from '../constants/genders';

class GenderIcon extends React.Component {
    render() {
        let {user} = this.props;

        if (!user || !user.nick) return null;

        let icon;
        switch (user.gender) {
            case GENDER_MALE: icon = <span className="gender-icon male"/>; break;
            case GENDER_FEMALE: icon = <span className="gender-icon female"/>; break;
            case GENDER_COUPLE: icon = <span className="gender-icon couple"/>; break;
            case GENDER_TRANSVESTITE: icon = <span className="gender-icon transvestite"/>; break;
        }

        return icon;
    }
}

GenderIcon.propTypes = {
    user: PropTypes.object.isRequired,
    className: PropTypes.string,
};

export default GenderIcon;


// WEBPACK FOOTER //
// ./src/components/GenderIcon.js